// Acceso al CRM de agencias.
//
// Entran el dueño del CRM (AGENCY_CRM_OWNER_UID del Worker), los ADMIN de
// TikControl (como editores, sin permiso) y los viewers que él haya dado de
// alta en Ajustes → Acceso. A los demás viewers el Worker les responde 403
// `crm_forbidden` (cf-worker/src/lib/agencyCrm.js › crmRole).
//
// Cuando una cuenta recibe esa respuesta se recuerda aquí, en memoria y por
// uid, para que la pestaña «Agencias» la lleve directa al directorio sin volver
// a pedir el CRM entero. Al recargar la página se vuelve a comprobar, por si ya
// le han dado acceso.

export const CRM_FORBIDDEN = 'crm_forbidden';

const denied = new Set();

export function isCrmForbidden(response) {
  return response?.status === 403 && response?.data?.error === CRM_FORBIDDEN;
}

export function markCrmDenied(uid) {
  if (uid) denied.add(uid);
}

export function crmDenied(uid) {
  return !!uid && denied.has(uid);
}

export function clearCrmDenied(uid) {
  if (uid) denied.delete(uid);
}
